import React from "react";
import { Image, imageHost } from "@wss/image";
import { Image as ImageModel, ModelFiles, Video } from "~/common/MediaViewerV2/model";
interface ImageGalleryRendererProps {
  index: number;
  media: (ImageModel | Video | ModelFiles)[];
  image: ImageModel;
  handleThumbnailClick: (e: React.MouseEvent<HTMLAnchorElement>, index: number) => void;
  borderStyling: string;
}
const ImageGalleryRenderer = ({
  index,
  media,
  image,
  handleThumbnailClick,
  borderStyling
}: ImageGalleryRendererProps) => {
  return <a aria-label={`gallery item ${index + 1} of ${media.length}`} role="button" href={`#slide-${index}`} data-testid="image-dot" onClick={e => {
    handleThumbnailClick(e, index);
  }} className={`
        ${borderStyling}
        relative 
        block 
        before:content-[''] 
        before:absolute 
        before:inset-0 
        before:border-solid 
        before:rounded 
        [@media(hover:hover)]:hover:before:border-2 
        [@media(hover:hover)]:hover:before:border-gray-700 
        focus:outline 
        focus:outline-3 
        focus:outline-offset-[-3px] 
        focus:outline-transparent 
        focus-visible:before:border-[3px] 
        focus-visible:before:border-[#005FCC]
      `} data-sentry-component="ImageGalleryRenderer" data-sentry-source-file="ImageGalleryRenderer.tsx">
      <Image height={1} width={1} className="max-w-none w-full box-border block p-1-1/2 h-auto" src={`${imageHost}${image.thumbnail}`} alt={image.alternateText} data-sentry-element="Image" data-sentry-source-file="ImageGalleryRenderer.tsx" />
    </a>;
};
export default ImageGalleryRenderer;